import NavBar from "../Navbar/Navbar";
import SideBar from "../Sidebar/SideBar";
import "./School-District.css";
import { Link, useParams } from "react-router-dom";
import getCookie, { setAdminCookie, userState } from "../../Atom";
import { useEffect, useState } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { visuallyHidden } from "@mui/utils";
import PropTypes from "prop-types";
import {
  createSchool,
  getSchoolByDistrict,
  getSchoolDistrictsById,
  getSchoolDistrictsAnalytics,
  getSchoolById,
  editSchoolById,
  deleteSchoolById,
} from "./api";
import { CircularProgress, Modal } from "@material-ui/core";
import ManageSchoolAdmin from "./ManageSchoolAdmin";
import ManageSchoolDevice from "../ManageSchoolDevice/ManageSchoolDevice";
import Dialog from "@mui/material/Dialog";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogTitle from "@mui/material/DialogTitle";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import * as React from "react";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Box,
  TableContainer,
} from "@mui/material";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const headCells = [
  {
    id: "_id",
    numeric: false,
    disablePadding: true,
    label: "Id",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            padding={"normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              sx={{ display: "flex", justifyContent: "left !important" }}
              className=" mb-2"
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="div" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell align={"center"} padding={"normal"}>
          <div className=" mb-2 ">Manage</div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
export default function District() {
  const history = useHistory();
  let search = window.location.search;
  let paramse = new URLSearchParams(search);
  const [myUser, setmyUser] = useState(userState);
  const [selected, setSelected] = React.useState([]);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [color, setColor] = useState("red");
  const [showManage, setShowManage] = useState(false);
  const [schoolDistrictData, setSchoolDestrictData] = useState({});
  const [schools, setSchools] = useState([]);
  const [schoolId, setSchoolId] = useState("");
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);
  let params = useParams();
  const [show, setShow] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const [dashboardAnalytics, setdashboardAnalytics] = useState({});
  // const {token} = useRecoilValue(userState)
  const [currPage, setCurrPage] = useState(0);
  const [paged, setPaged] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [noOfPages, setNoOfPages] = useState(0);
  const [pageLimit, setPageLimit] = useState(25);

  const [snackBarShow, setSnackBarShow] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("");

  const logoutHandler = async () => {
    setTimeout(() => {
      // setmyUser({
      //   fName: null,
      //   userId: null,
      //   token: null,
      //   lName: null,
      // })
      setAdminCookie({
        fName: null,
        lName: null,
        token: null,
        userId: null,
      });
      let hostname = window.location.host;
      ////console.loghostname,window.location.protocol)
      window.location.assign(
        `${window.location.protocol}//${hostname}/super-admin`
      );
    });
  };

  const handleShowManageDevice = () => {
    setShowManage(false);
  };
  const getAnalytic = async (user) => {
    let res = await getSchoolDistrictsAnalytics(params.districtId, user.token);
    if (res.error) {
      // alert('Could not get analytics. Try Again')
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      ////console.logres.res.data.data)
      setdashboardAnalytics(res.res.data.data);
      //    setDevices(res.res.data.data)
    }
  };
  const onSetOrder = (event, property) => {
    var orderTemp = order === "asc" ? "desc" : "asc";
    let urltPage = parseInt(paramse.get("page")) || 0;
    let urltLimit = parseInt(paramse.get("limit")) || pageLimit;
    getAllSchoolDestrictWise(urltPage, urltLimit, property, orderTemp);
    history.replace({
      pathname: `/district/${params.districtId}`,
      search:
        "?page=" +
        urltPage +
        "&limit=" +
        pageLimit +
        "&orderBy=" +
        property +
        "&order=" +
        orderTemp,
    });
    setOrderBy(property);
    setOrder(orderTemp);
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = schools.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const getDeviceDetails = async (id, type) => {
    if (type === "edit") setEditMode(true);
    else setDeleteMode(true);
    setSchoolId(id);
    setShow(true);
    let res = await getSchoolById(params.districtId, id, myUser.token);
    if (res.error) {
      // alert("Could not fetch Device Details. Try Again");
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      ////console.logres.res.data.data.school);
      setName(res.res.data.data.school.name);
      // setSchoolDistrictList(res.res.data.data.schoolDistricts);
    }
  };

  const handleChangePage = (event, newPage) => {
    ////console.logevent)
    setPaged(event.selected);
    let urlOrderBy = paramse.get("orderBy") || "createdAt";
    let urlOrder = paramse.get("order") || "desc";
    getAllSchoolDestrictWise(event.selected, pageLimit, urlOrderBy, urlOrder);
    history.replace({
      pathname: `/district/${params.districtId}`,
      search:
        "?page=" +
        event.selected +
        "&limit=" +
        pageLimit +
        "&orderBy=" +
        urlOrderBy +
        "&order=" +
        urlOrder,
    });
  };

  const handleshowAdminManage = () => {
    setShowAdmin(false);
    ////console.logshowAdmin)
  };
  const ManageModal = (id) => {
    setSchoolId(id);
    setShowManage(true);
  };
  const submitHandler = async (e) => {
    e.preventDefault();
    let id = params.districtId;
    let data = { name: name.trim() };
    let res;
    if (!editMode && !deleteMode) {
      res = await createSchool(id, data, myUser.token);
    } else if (editMode) {
      res = await editSchoolById(id, schoolId, data, myUser.token);
    } else {
      res = await deleteSchoolById(id, schoolId, myUser.token);
    }
    if (res.error) {
      // alert("Failed to perform this operation. Try Again");
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
      setColor("red");
    } else {
      ////console.logres);
      setColor("green");
      history.replace({
        pathname: `/district/${params.districtId}`,
        search:
          "?page=" +
          paged +
          "&limit=" +
          pageLimit +
          "&orderBy=" +
          orderBy +
          "&order=" +
          order,
      });
      getAllSchoolDestrictWise(paged, pageLimit, orderBy, order);
      setName("");
      setDeleteMode(false);
      setEditMode(false);
    }
    setShow(false);
  };

  useEffect(() => {
    const _cookie = getCookie("recoil-persist");
    if (!_cookie) {
      logoutHandler();
    } else {
      const user = JSON.parse(_cookie)["KT_app"];
      setmyUser(user);
      getSchoolDistrictDetails(user);
      getAnalytic(user);
      let urlPage = parseInt(paramse.get("page")) || 0;
      let urlLimit = parseInt(paramse.get("limit")) || pageLimit;
      let urlOrderBy = paramse.get("orderBy") || "createdAt";
      let urlOrder = paramse.get("order") || "desc";
      ////console.logurlPage)
      if (parseInt(paramse.get("page")) || urlLimit) {
        ////console.log'lol1')
        history.replace({
          pathname: `/district/${params.districtId}`,
          search:
            "?page=" +
            urlPage +
            "&limit=" +
            urlLimit +
            "&orderBy=" +
            urlOrderBy +
            "&order=" +
            urlOrder,
        });
        setPaged(urlPage);
        setPageLimit(urlLimit);
        setOrderBy(urlOrderBy);
        setOrder(urlOrder);
        getAllSchoolDestrictWise(urlPage, urlLimit, orderBy, order, user);
      } else {
        ////console.log'lol')
        setPaged(0);
        history.push({
          pathname: `/district/${params.districtId}`,
          search: `?page=0&limit=${pageLimit}&orderBy=${orderBy}&order=${order}`,
        });
        getAllSchoolDestrictWise(0, pageLimit, orderBy, order, user);
      }
    }
  }, [0]);

  const getSchoolDistrictDetails = async (user) => {
    let res = await getSchoolDistrictsById(params.districtId, user?.token);
    ////console.logres);
    if (res.error) {
      // alert("Cant Fetch Data School Destrict Data");
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      setSchoolDestrictData(res.res.data.data.schoolDistrict);
    }
  };
  const getAllSchoolDestrictWise = async (
    pages,
    limits,
    orderBy = "createdAt",
    order = "desc",
    user = myUser
  ) => {
    let res = await getSchoolByDistrict(
      params.districtId,
      user?.token,
      pages,
      limits,
      orderBy,
      order
    );
    ////console.logres);
    if (res?.error) {
      // alert("Cant Fetch District Data. Try Again");
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
    } else {
      ////console.logres.res.data.data.schools);
     //console.log"res....", res);
      setSchools(res?.res?.data?.data?.schools);
      let divisor = parseInt(res?.res?.data?.data?.totalcount / limits);
      let remainder = parseInt(
        res?.res?.data?.data?.totalcount % limits == 0 ? 0 : 1
      );
      ////console.logdivisor,remainder)
      ////console.log'Ok',limits,res.res.data.data.totalcount,(parseInt(res.res.data.data.totalcount)%limits)===0?0:1)
      ////console.log'Check value of remainder',parseInt(res.res.data.data.totalcount%limits)==0?0:1)
      setNoOfPages(divisor + remainder);
      setCurrPage(pages);
      // setSchoolDestrictData(res.res.data.data.schoolDistrict)
    }
  };

  const handleClose = () => {
    setShow(false);
    setEditMode(false);
    setDeleteMode(false);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const handleShow = () => {
    setShow(true);
  };

  const feedBackMsg = (snackShow, snackSeverity, snackMessage) => {
    setSnackBarShow(snackShow);
    setSnackBarSeverity(snackSeverity);
    setSnackBarMessage(snackMessage);
  };

  const SnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    feedBackMsg(false, "", "");
  };

  const handleChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 10));
    setPageLimit(parseInt(event.target.value, 10));
    setPaged(0);
    ////console.log'Row change')
    getAllSchoolDestrictWise(0, parseInt(event.target.value, 10));
    history.push({
      pathname: `/district/${params.districtId}`,
      search: "?page=0" + "&limit=" + parseInt(event.target.value, 10),
    });
  };

  ////console.logshowAdmin)
  return (
    <section id="hero-school ">
      {showManage ? (
        <ManageSchoolDevice
          destrictId={params.districtId}
          schoolId={schoolId}
          token={myUser?.token}
          showManageDevice={handleShowManageDevice}
        />
      ) : null}
      {showAdmin ? (
        <ManageSchoolAdmin
          schoolId={schoolId}
          showAdminManage={handleshowAdminManage}
          districtId={params.districtId}
          token={myUser?.token}
        />
      ) : null}

      <Dialog handleClose={handleClose} open={show} fullWidth>
        <section id="hero-Msd">
          {/* <div className="row main-div-modal">
            <div className="col-md-6 m-auto center-div text-center">
              <div className="p-2 center-div">
                <h2>
                  <button onClick={handleClose} className="btn close-btn rounded-circle float-right">
                    <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="20" cy="20" r="20" fill="#011627"/>
                      <path d="M27.0693 13.1005L12.9272 27.2426" stroke="white" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M27.0693 27.2426L12.9272 13.1005" stroke="white" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                  </button>
                </h2> */}
          {!editMode && !deleteMode ? (
            <>
              {/* <div className="mt-3">
                    <h6>New School </h6>
                  </div> */}
              <DialogTitle>
                <Grid container justify="space-between" alignItems="center">
                  <Typography variant="h6" style={{ fontWeight: "600" }}>
                    Add School
                  </Typography>
                  <IconButton onClick={handleClose}>
                    <CloseIcon
                      style={{ border: "2px solid black", fontSize: "30px" }}
                    />
                  </IconButton>
                </Grid>
              </DialogTitle>
              <div className="col-md-9 text-left  col-9 m-auto">
                <div className="form-group mt-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="School  Name"
                    value={name}
                    onBlur={(e) => setName(e.target.value.trim())}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>

                <div className="form-group">
                  {loading ? (
                    <CircularProgress />
                  ) : (
                    <button
                      type="submit"
                      className="cta-btn"
                      onClick={submitHandler}
                      disabled={name.trim().length < 1}
                    >
                      Add
                    </button>
                  )}
                </div>
              </div>
            </>
          ) : editMode ? (
            <>
              {/* <div className="mt-3">
                    <h6>Edit School</h6>
                  </div> */}
              <DialogTitle>
                <Grid container justify="space-between" alignItems="center">
                  <Typography variant="h6" style={{ fontWeight: "600" }}>
                    Edit School
                  </Typography>
                  <IconButton onClick={handleClose}>
                    <CloseIcon
                      style={{ border: "2px solid black", fontSize: "30px" }}
                    />
                  </IconButton>
                </Grid>
              </DialogTitle>
              {/* <br /> */}
              <div className="col-md-9 text-left  col-9 m-auto">
                <div className="form-group mt-4">
                  <input
                    type="text"
                    value={name}
                    className="form-control"
                    placeholder="School Destrict Name"
                    onBlur={(e) => setName(e.target.value.trim())}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                {/* <br /> */}
                {/* <br /> */}
                {/* <br /> */}
                <div className="form-group">
                  {loading ? (
                    <CircularProgress />
                  ) : (
                    <button
                      type="submit"
                      className="cta-btn"
                      onClick={submitHandler}
                      disabled={name.trim().length < 1}
                    >
                      Edit
                    </button>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              {/* <div className="mt-3">
                    <h6>Remove School District</h6>
                  </div> */}
              <DialogTitle>
                <Grid container justify="space-between" alignItems="center">
                  <Typography variant="h6" style={{ fontWeight: "600" }}>
                    Delete School
                  </Typography>
                  <IconButton onClick={handleClose}>
                    <CloseIcon
                      style={{ border: "2px solid black", fontSize: "30px" }}
                    />
                  </IconButton>
                </Grid>
              </DialogTitle>
              <div className="col-md-9 text-left  col-9 m-auto">
                <div className="form-group mt-4   p-20">
                  <h5>Are you Sure to Delete this School?</h5>
                  <br />
                  <input
                    type="text"
                    readOnly
                    value={name}
                    className="form-control"
                    placeholder="School Destrict Name"
                  />
                </div>
                {/* <br /> */}
                {/* <br /> */}
                <div className="form-group">
                  {loading ? (
                    <CircularProgress />
                  ) : (
                    <button
                      type="submit"
                      className="cta-btn-red"
                      onClick={submitHandler}
                    >
                      Delete
                    </button>
                  )}
                </div>
              </div>
            </>
          )}
          {/* </div>
            </div>
          </div> */}
        </section>
      </Dialog>

      <div>
        <NavBar />
        <br />
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" to={"/school-districts/"}>
            School District
          </Link>
          <Typography color="text.primary">School</Typography>
          {/* <Link underline="hover" color="inherit" href="/">Breadcrumbs</Link> */}
        </Breadcrumbs>
        <div className="dashboard-heading ml-4 textCap">
          <h2>{schoolDistrictData.name}</h2>
        </div>
        <div className="dashboard-notification-cards m-auto row">
          <div className="col-md-3 col-sm-12 notification-card p-3">
            <h2> {dashboardAnalytics.school}</h2>
            <h6 className="ml-2 notification-subHeading span-h4">School</h6>
          </div>
          <div className="col-md-3 col-sm-12 notification-card p-3">
            <h2> {dashboardAnalytics.teacher}</h2>

            <h6 className="ml-2 notification-subHeading span-h4">Teachers</h6>
          </div>
          <div className="col-md-3 col-sm-12 notification-card p-3">
            <h2> {dashboardAnalytics.student}</h2>

            <h6 className="ml-2 notification-subHeading span-h4">Students</h6>
          </div>
          <div className="col-md-3 col-sm-12 notification-card p-3">
            <h2> {dashboardAnalytics.device}</h2>

            <h6 className="ml-2 notification-subHeading span-h4">Device</h6>
          </div>
        </div>

        <div className="mt-5">
          <h2>
            Schools
            {schoolDistrictData.schoolId === undefined ? (
              <Link onClick={handleShow}>
                <button className="btn btn-add-device float-right ">
                  <i className="fas fa-plus-circle"></i> {"  "}
                  <span>Add new School</span>
                </button>
              </Link>
            ) : null}
          </h2>
        </div>
        <br />
        <div className="d-flex justify-content-end align-items-end">
          <ReactPaginate
            previousLabel="Previous"
            nextLabel="Next"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={noOfPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handleChangePage}
            containerClassName="pagination"
            activeClassName="activePage active"
            forcePage={currPage}
          />
        </div>
        {/* <div className="d-flex justify-content-end align-items-end">
                  <Box sx={{ minWidth: 100,backgroundColor:"white"}} >
                      <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label">Page</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={pageLimit}
                          label="Age"
                          onChange={handleChangeRowsPerPage}
                          >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                        </Select>
                      </FormControl>
                  </Box>
              </div> */}
        <TableContainer sx={{ height: "80vh", overflow: "auto" }}>
          <Table className="table">
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={onSetOrder}
              rowCount={schools?.length}
            />
            <TableBody>
              {schools?.map((item, index) => {
                const isItemSelected = isSelected(item.name);
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <TableRow key={index} hover role="checkbox" tabIndex={-1}>
                    <TableCell className="table-data">{item._id}</TableCell>
                    <TableCell className="table-data textCap">
                      <Link
                        className="sec-link"
                        to={
                          "/district/" +
                          params.districtId +
                          "/school/" +
                          item._id
                        }
                      >
                        {item.name}
                      </Link>
                    </TableCell>
                    <TableCell>
                      <Tooltip title="Device" placement="top">
                        <Link onClick={() => ManageModal(item._id)}>
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.0001 3.78098C21.0001 2.9106 20.7519 2.22182 20.2628 1.73416C18.2989 -0.22235 13.1357 1.85807 8.5061 6.47203C8.33788 6.63971 8.18413 6.81846 8.03629 7.00165C7.98776 6.98159 7.93191 6.96365 7.86769 6.94871C6.53437 6.63712 2.25517 7.36406 1.00944 12.3409C0.977382 12.4685 1.02866 12.6021 1.1376 12.6757C1.19041 12.7117 1.25145 12.7294 1.31247 12.7294C1.37685 12.7294 1.44126 12.7096 1.49588 12.6699C3.1867 11.4434 4.54315 10.95 5.72724 11.1316C5.64553 11.2798 5.56259 11.4243 5.47693 11.5624C5.40031 11.686 5.41893 11.8459 5.52178 11.9484L6.01212 12.4372L5.09424 13.3517C5.03534 13.4102 5.00237 13.4899 5.00237 13.5729C5.00237 13.6559 5.03534 13.7356 5.09424 13.7942L8.16585 16.8557C8.22688 16.9164 8.30651 16.9469 8.38648 16.9469C8.46644 16.9469 8.5461 16.9164 8.60713 16.8557L9.52623 15.9395L10.018 16.4297C10.0784 16.4898 10.1581 16.5209 10.2386 16.5209C10.295 16.5209 10.3518 16.5056 10.4025 16.4745C10.6316 16.3949 10.6657 16.3175 10.8036 16.2414C11.0071 17.4313 10.6143 18.7964 9.26814 20.6032C9.19064 20.6094 9.18789 20.7528 9.2611 20.8617C9.32001 20.9496 9.41798 21 9.52051 21C9.54555 21 9.57086 20.9969 9.59589 20.9908C14.5773 19.7521 15.3134 15.4879 15.0064 14.1579C14.9876 14.0767 14.963 14.0128 14.9364 13.9562C15.135 13.7992 15.3285 13.6353 15.5093 13.4551C18.8449 10.1308 21.0001 6.33318 21.0001 3.78098ZM6.018 10.6465C4.7988 10.2895 3.45908 10.6469 1.8682 11.6597C2.65067 9.48841 4.07586 8.46269 5.19402 7.9796C6.03234 7.61766 6.79528 7.51634 7.28356 7.51634C7.4145 7.51634 7.52525 7.52366 7.61285 7.53497L6.018 10.6465ZM8.38648 16.1931L5.75768 13.5729L6.45472 12.8786L8.72582 15.1418L9.08351 15.4983L8.38648 16.1931ZM13.9792 16.8041C13.4958 17.9238 12.4661 19.3505 10.2801 20.1327C11.2945 18.5485 11.6531 17.2143 11.3958 15.9984L14.4189 14.4078C14.4732 14.8186 14.4336 15.7513 13.9792 16.8041ZM11.8405 15.0203C11.2909 15.2849 10.7675 15.5364 10.2871 15.8153L6.1364 11.6786C6.36056 11.2948 6.56778 10.878 6.77766 10.4474L8.04666 8.05144C8.31226 7.64031 8.60651 7.25434 8.94738 6.91453C13.1827 2.69332 18.1616 0.623809 19.8215 2.17666C20.1889 2.54288 20.3751 3.08273 20.3751 3.78098C20.3751 6.13877 18.2422 9.84882 15.068 13.0126C14.1839 13.8936 12.9925 14.4664 11.8405 15.0203Z"
                              fill="#495057"
                              stroke="#495057"
                              strokeWidth="0.6"
                            />
                            <path
                              d="M14.3522 5.01655C13.9961 5.37086 13.7998 5.84236 13.7998 6.34405C13.7998 6.84608 13.9961 7.31759 14.3522 7.6719C14.7193 8.03718 15.2015 8.22 15.6837 8.22C16.1658 8.22 16.648 8.03718 17.0149 7.6719C17.371 7.31759 17.5669 6.84608 17.5669 6.34405C17.5669 5.84236 17.371 5.37086 17.0149 5.01655C16.2812 4.28595 15.0864 4.28595 14.3522 5.01655ZM16.5742 7.22877C16.0829 7.71765 15.2842 7.71765 14.7929 7.22877C14.5557 6.99255 14.4248 6.67852 14.4248 6.34405C14.4248 6.00989 14.5557 5.69586 14.7929 5.45964C15.0385 5.2152 15.3611 5.09314 15.6837 5.09314C16.0063 5.09314 16.3285 5.2152 16.5742 5.45964C16.8113 5.69586 16.9419 6.00989 16.9419 6.34405C16.9419 6.67852 16.8113 6.99255 16.5742 7.22877Z"
                              fill="#495057"
                              stroke="#495057"
                              strokeWidth="0.6"
                            />
                            <path
                              d="M6.14454 15.7335C6.02279 15.6111 5.82504 15.6111 5.70266 15.7329L2.57918 18.846C2.45708 18.9677 2.45649 19.1655 2.57855 19.2879C2.63958 19.3492 2.71955 19.3797 2.79981 19.3797C2.87946 19.3797 2.95943 19.3492 3.02046 19.2885L6.14394 16.1754C6.26601 16.0536 6.26663 15.8558 6.14454 15.7335Z"
                              fill="#495057"
                              stroke="#495057"
                              strokeWidth="0.6"
                            />
                            <path
                              d="M2.78994 17.2417C2.86959 17.2417 2.94953 17.2111 3.0106 17.1504L5.06748 15.1002C5.18954 14.9785 5.18985 14.7807 5.06807 14.6583C4.94632 14.536 4.74857 14.5356 4.62619 14.6577L2.56928 16.7079C2.44722 16.8297 2.4469 17.0274 2.56868 17.1498C2.62972 17.2111 2.70969 17.2417 2.78994 17.2417Z"
                              fill="#495057"
                              stroke="#495057"
                              strokeWidth="0.6"
                            />
                            <path
                              d="M6.78241 16.8074L4.72553 18.8576C4.60346 18.9793 4.60315 19.1771 4.72493 19.2995C4.78597 19.3608 4.8659 19.3913 4.94619 19.3913C5.02581 19.3913 5.10578 19.3608 5.16681 19.3001L7.22373 17.2499C7.34579 17.1281 7.34611 16.9304 7.22432 16.808C7.10257 16.6856 6.90479 16.6853 6.78241 16.8074Z"
                              fill="#495057"
                              stroke="#495057"
                              strokeWidth="0.6"
                            />
                          </svg>
                        </Link>
                      </Tooltip>
                      &nbsp;
                      <Tooltip title="Edit" placement="top">
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            getDeviceDetails(item._id, "edit");
                          }}
                        >
                          <i className="fas fa-edit icon-size-30"></i>
                        </span>
                      </Tooltip>
                      &nbsp;
                      <Tooltip title="Delete" placement="top">
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            getDeviceDetails(item._id, "delete");
                          }}
                        >
                          <i className="fas fa-trash-alt icon-size-30"></i>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <Snackbar
        open={snackBarShow}
        autoHideDuration={3000}
        onClose={SnackClose}
      >
        <Alert
          onClose={SnackClose}
          severity={snackBarSeverity}
          sx={{ width: "100%" }}
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
    </section>
  );
}
